import { render, staticRenderFns } from "./PostTagInput.vue?vue&type=template&id=4ecc99a8&lang=pug&"
import script from "./PostTagInput.vue?vue&type=script&lang=js&"
export * from "./PostTagInput.vue?vue&type=script&lang=js&"
import style0 from "./PostTagInput.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports